import { useKorintConfig } from 'korint-sdk/react';
import { useMemo } from 'react';

const defaultPolicyStatuses: Record<string, string> = {
  POLICY_CREATED: 'bg-indigo-100 text-indigo-700',
  POLICY_QUOTED: 'bg-indigo-100 text-indigo-700',
  POLICY_CONFIRMED: 'bg-indigo-100 text-indigo-700',
  POLICY_SIGNED: 'bg-indigo-100 text-indigo-700',
  POLICY_STARTED: 'bg-green-100 text-green-700',
  POLICY_STOPPED: 'bg-red-100 text-red-700',
  POLICY_SUSPENDED: 'bg-yellow-100 text-yellow-700',
  QUOTE_TO_BE_APPROVED: 'bg-amber-100 text-amber-700',
  DEROGATION_APPROVED: 'bg-green-100 text-green-700',
};

export function usePolicyStatuses(): Record<string, string> {
  const { policyStatuses } = useKorintConfig().korintConfig;

  return useMemo(() => ({ ...defaultPolicyStatuses, ...policyStatuses }), [policyStatuses]);
}
